import React, { useCallback, useEffect, useState } from 'react';
import useFlexBoxStyles from 'common/flexBox';
import { makeStyles } from 'tss-react/mui';
import { keyframes } from 'tss-react';

const time = keyframes`
0%, 70% {
    opacity: 0.8;
}
100% {
    opacity: 0;
}

`;

const useStyles = makeStyles()((theme) => ({
    label: {
        width: theme.spacing(25),
        height: theme.spacing(25),
        fontSize: '10rem',
        fontWeight: '400',
        opacity: 0.8,
        color: theme.palette.background.paper,
        textShadow: '0px 1px 2px #00000029',
        animation: `${time} 1s linear 0s 5 normal none`,
    },
}));

const TIME_LIMIT = 3;

const Countdown = ({ onFinished }) => {
    const { classes, cx } = useStyles();
    const { classes: flexBox } = useFlexBoxStyles();

    const [timePassed, setTimePassed] = useState(0);
    const [timeLeft, setTimeLeft] = useState(TIME_LIMIT);
    const [timerInterval, setTimerInterval] = useState(null);

    const increaseTime = useCallback(() => {
        setTimePassed(timePassed + 1);
    }, [timePassed])

    const startTimer = useCallback(() => {
        setTimerInterval(setInterval(() => {
            increaseTime();
        }, 1000));
    }, [increaseTime]);

    useEffect(() => {
        if (timeLeft === 0) {
            clearInterval(timerInterval);
            onFinished();
        }
    }, [timeLeft, onFinished, timerInterval]);

    useEffect(() => {
        setTimeLeft(TIME_LIMIT - timePassed);
    }, [timePassed]);

    useEffect(() => {
        startTimer();
    }, [startTimer]);

    return (
        <div
            className={cx(
                flexBox.absolute,
                flexBox.top0,
                flexBox.left0,
                flexBox.w100,
                flexBox.h100,
                flexBox.flex,
                flexBox.justifyContentCenter,
                flexBox.alignItemsCenter,
            )}
        >
            <span
                id="base-timer-label"
                className={cx(
                    flexBox.flex,
                    flexBox.alignItemsCenter,
                    flexBox.justifyContentCenter,
                    classes.label,
                )}
            >
                {timeLeft}
            </span>
        </div>
    );
};

export default Countdown;
